import {
  getListNotificationsQueryKey,
  useListNotifications,
} from "@workspace/api-client-react";

export function useUnreadNotificationCount(): number {
  const notifications = useListNotifications(undefined, {
    query: {
      queryKey: getListNotificationsQueryKey(),
      staleTime: 10_000,
    },
  });
  return notifications.data?.unreadCount ?? 0;
}

export function formatUnreadNotificationCount(count: number): string {
  return count > 99 ? "99+" : String(count);
}
